var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    style: {
      enableBackground: "new 0 0 512 512"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M309.53 54.211c202.223 135.313 136.646 284.006 136.646 284.006s57.44 63.738 34.351 119.572c0 0-23.83-39.004-63.388-39.004-38.243 0-60.866 39.004-138.061 39.004-171.691 0-253.077-141.076-253.077-141.076 154.725 100.318 260.438 29.227 260.438 29.227C216.58 306.219 68.406 115.981 68.406 115.981 197.577 224.118 253.319 252.51 253.319 252.51 219.802 225.531 126.391 93.294 126.391 93.294 201.14 167.64 349.72 271.309 349.72 271.309c42.606-114.562-40.19-217.098-40.19-217.098z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwift);
export default __webpack_public_path__ + "static/media/swift.2370d90a43154d78db248ac7083c4717.svg";
export { ForwardRef as ReactComponent };